import Breadcrumb from "../breadcrumb/Breadcrumb";
import { HOME_CRUMB } from "../../constants/BreadcrumConstants";
import { HTMLParserHelper } from "../../helper/HTMLParserHelper";
const MenuHeader = ({
  crumbs,
  title,
  content,
  extStyle,
  containerClass,
  textColor,
  breadCrumbColor,
  labelColor,
}) => {
  return (
    <div className={containerClass} style={extStyle}>
      <div className="row">
        <div className={`container ${breadCrumbColor}`}>
          <Breadcrumb crumbs={[HOME_CRUMB, ...crumbs]} />

          <div className="row">
            <div
              className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 ${textColor}`}
            >
              <div className={`pull-left ${labelColor}`}>{title}</div>
              {HTMLParserHelper(content)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuHeader;
